import { Toaster } from 'sonner'

export function AppProviders({ children }) {
  return (
    <>
      {children}
      <Toaster
        closeButton
        position="bottom-right"
        offset={{ bottom: '24px', right: '16px' }}
        mobileOffset={{ bottom: '16px', right: '12px', left: '12px' }}
        gap={8}
        duration={5000}
        visibleToasts={5}
        style={{ zIndex: 2000 }}
        toastOptions={{
          classNames: {
            toast:
              'group toast !flex !w-auto !min-w-[200px] !max-w-[calc(100vw-1.5rem)] sm:!max-w-[380px] !items-center !gap-2.5 !rounded-xl !border !border-border !bg-white !pl-3.5 !pr-10 !py-2.5 !text-[13px] !font-medium !text-foreground !shadow-lg relative',
            title: '!text-[13px] !font-medium !leading-snug !break-words',
            description: '!text-xs !text-muted-foreground !break-words',
            icon: '!size-4 !shrink-0',
            closeButton:
              '!absolute !top-1/2 !right-2.5 !left-auto !translate-x-0 !-translate-y-1/2 !bg-slate-100 !text-slate-500 hover:!bg-slate-200 hover:!text-slate-700 !border-none',
            success:
              '!border-emerald-200 !bg-white !text-emerald-700 [&_[data-icon]]:!text-emerald-600',
            error:
              '!border-red-200 !bg-white !text-red-700 [&_[data-icon]]:!text-red-600',
            info: '!border-sky-200 !bg-white !text-sky-700 [&_[data-icon]]:!text-sky-600',
            warning:
              '!border-amber-200 !bg-white !text-amber-700 [&_[data-icon]]:!text-amber-600',
          },
        }}
      />
    </>
  )
}
